export default __webpack_public_path__ + "static/9-0eedbd140edd3ac5a179e1b1b4c3161c.png";